import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "header-panel" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "mt-6"
};
const _hoisted_4 = {
    key: 1,
    class: "mt-6"
};
const _hoisted_5 = {
    key: 2,
    class: "centered"
};
import { ref, onMounted } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { useAppState } from '@/composables/useAppState';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FeaturedVouchersPage',
    setup(__props) {
        useAuth();
        const state = useAppState();
        const { getCustomer } = useCustomer();
        const { getAvailableVouchers, addCustomerFavouriteDiscount, removeCustomerFavouriteDiscount } = useVouchers();
        const loading = ref(true);
        const featuredVouchers = ref(null);
        const formatter = state.formatter;
        function onLoad() {
            getCustomer();
            loadAvailable();
        }
        function loadAvailable() {
            getAvailableVouchers(() => {
                featuredVouchers.value = state.availableVouchers.filter((v) => v.featured);
                loading.value = false;
            });
        }
        function favouriteToggled(voucher) {
            if (voucher.favourite) {
                removeCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
            else {
                addCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Featured" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_row, { class: "content-row" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "v-col-8" }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createElementVNode("h1", { class: "title" }, "Featured", -1)
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_col, { class: "v-col-4 voucher-count" }, {
                                default: _withCtx(() => [
                                    (featuredVouchers.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(featuredVouchers.value.length) + " Vouchers", 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                (featuredVouchers.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(VoucherList, {
                            showAll: true,
                            vouchers: featuredVouchers.value,
                            search: false,
                            showSaving: false,
                            showFavourites: true,
                            onFavouriteToggled: _cache[0] || (_cache[0] = (v) => { favouriteToggled(v); }),
                            formatter: _unref(formatter)
                        }, null, 8, ["vouchers", "formatter"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                            return _createElementVNode("div", {
                                key: i,
                                class: "mb-2"
                            }, [
                                _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line" })
                            ]);
                        }), 64))
                    ])),
                (!loading.value && featuredVouchers.value.length == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, " No vouchers available at this time. "))
                    : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
            ], 64));
        };
    }
});
